import { render, staticRenderFns } from "./HomepageTile.vue?vue&type=template&id=37f53876"
import script from "./HomepageTile.vue?vue&type=script&lang=js"
export * from "./HomepageTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports